import React from 'react';

const NotFound = () => {
    return (
        <div className="max-w-7xl mx-auto px-5 mb-8 md:mb-16">
            <div className="text-center text-4xl text-gray-600 my-10 font-medium">
                <h2 className="text-5xl mb-3">4o4</h2>
                <h3 className="text-4xl">Not Found</h3>
            </div>
        </div>
    );
};

export default NotFound;